import React from 'react'
import { withIcon } from '../../withIcon'

function VKIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M20.2795 5.441C20.5882 5.59537 20.7134 5.97079 20.559 6.27952C20.043 7.31156 19.2717 8.59728 18.3683 9.75873C17.7153 10.5983 16.968 11.4062 16.1731 12C16.968 12.5938 17.7153 13.4017 18.3683 14.2413C19.2717 15.4027 20.043 16.6885 20.559 17.7205C20.7134 18.0292 20.5882 18.4047 20.2795 18.559C19.9708 18.7134 19.5954 18.5883 19.441 18.2795C18.957 17.3116 18.2283 16.0973 17.3817 15.0087C16.5658 13.9597 15.6832 13.0836 14.8464 12.625H12.625V18C12.625 18.1896 12.539 18.3689 12.3911 18.4875C12.2432 18.6062 12.0495 18.6513 11.8644 18.6101C9.41192 18.0651 7.29433 16.3124 5.67892 14.0508C4.05886 11.7827 2.90028 8.9454 2.38508 6.11182C2.32333 5.77221 2.54859 5.44684 2.8882 5.3851C3.22781 5.32335 3.55317 5.5486 3.61492 5.88821C4.09972 8.55463 5.19114 11.2173 6.69608 13.3242C8.01674 15.1732 9.62275 16.5505 11.375 17.1709V6.62501H10C9.65482 6.62501 9.375 6.34519 9.375 6.00001C9.375 5.65484 9.65482 5.37501 10 5.37501H12C12.3452 5.37501 12.625 5.65484 12.625 6.00001V11.375H14.8464C15.6832 10.9164 16.5658 10.0403 17.3817 8.9913C18.2283 7.90275 18.957 6.68847 19.441 5.72051C19.5954 5.41177 19.9708 5.28663 20.2795 5.441Z" fill={color}/>
    </svg>
  )
}

export default withIcon(VKIcon)
